import React, { Component } from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Divider from "./Divider";
import { connect } from "react-redux";
import SendButton from "../Components/WebElements/AddButton";
import Server from "./Server";
import { fetchLoaderRun } from "../actions";
import Progress from "./Progress";
import Success from "./WebElements/success";

const styles = (theme) => ({
	container: {
		display: "flex",
		flexWrap: "wrap"
	},
	textField: {
		marginLeft: 0,
		marginRight: theme.spacing.unit,
		width: "100%"
	},
	dense: {
		width: "100%",
		marginTop: 16,
		marginLeft: 0
	},
	menu: {
		width: 200
	}
});

class AddOpinion extends Component {
	state = {
		error: null,
		success: null,
		timeout: null
	};

	timeout = null;

	handleSubmit = (e) => {
		const { langBase, fetchLoaderRun } = this.props;
		const data = new URLSearchParams(new FormData(e.target));
		data.append("language", langBase.abbr);
		fetchLoaderRun(true);
		fetch(Server.URL + "submit", {
			body: data,
			method: "POST"
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.responseCode) {
					fetchLoaderRun(false);
					this.setState({
						success: null,
						error: langBase[data.responseDesc] ? langBase[data.responseDesc] : data.responseDesc
					});
					clearTimeout(this.state.timeout);
					let timeout = setTimeout(() => {
						this.resetError();
					}, 40000);
					this.setState({ timeout });
				} else {
					fetchLoaderRun(false);
					this.setState({
						error: null,
						success: langBase[data.responseDesc] ? langBase[data.responseDesc] : data.responseDesc
					});
				}
			})
			.catch((err) => {
				this.setState({ error: "Can't verify. No internet connection?" });
			});
	};

	resetError = () => {
		this.setState({ error: null });
	};

	componentDidMount() {
		this.timeout = setTimeout(() => {
			const preloadElem = document.querySelector("article.is-preload");
			preloadElem && preloadElem.classList.remove("is-preload");
		}, 500);

		if (window.grecaptcha) window.grecaptcha.render(document.getElementById("recaptcha"));
	}

	componentWillUnmount() {
		clearTimeout(this.timeout);
		clearTimeout(this.state.timeout);
	}

	render() {
		const { classes, langBase, fetching } = this.props;
		let error = null;

		if (this.state.error) {
			error = <div className="error">{this.state.error}</div>;
		}

		if (this.state.success) {
			return (
				<div
					id="main"
					style={{
						maxWidth: "342px",
						minWidth: "342px",
						padding: "0 20px",
						flexGrow: 1
					}}>
					<article id="testimonials" className="panel is-preload">
						<header>
							<div className="progress" style={{ height: "5px" }}>
								{fetching && <Progress />}
							</div>
							<h1 className="small-logo" style={{ fontSize: "25px" }}>
								{langBase.addOpinion || "DODAJ OPINIE"}
							</h1>
							<Divider width="100" />
						</header>
						<div className="main-box">
							<button
								onClick={this.props.handleClick}
								className="close"
								style={{
									position: "absolute",
									right: 0,
									top: 0,
									color: "#444444"
								}}>
								&times;
							</button>
							<div className="form">
								<Success />
								<div
									className="success"
									style={{
										marginBottom: "110px"
									}}>
									{this.state.success}
								</div>
							</div>
						</div>
					</article>
				</div>
			);
		}

		return (
			<div
				id="main"
				style={{
					maxWidth: "342px",
					padding: "0 20px",
					flexGrow: 1,
					minWidth: "320px",
					minHeight: "330px"
				}}>
				<article id="testimonials" className="panel is-preload">
					<header>
						<div className="progress" style={{ height: "5px" }}>
							{fetching && <Progress />}
						</div>
						<h1 className="small-logo" style={{ fontSize: "25px" }}>
							{langBase.addOpinion || "DODAJ OPINIE"}
						</h1>
						<Divider width="100" />
					</header>
					<div className="main-box">
						<button
							onClick={this.props.handleClick}
							className="close"
							style={{
								position: "absolute",
								right: 0,
								top: 0,
								color: "#444444"
							}}>
							&times;
						</button>
						<div className="form">
							<form
								onSubmit={this.handleSubmit}
								id="comment_form"
								action="javascript:grecaptcha.reset();"
								method="post"
								style={{ position: "relative" }}>
								<TextField
									id="outlined-dense"
									label={langBase.yourName || "Imię"}
									name="name"
									className={classNames(classes.textField, classes.dense)}
									margin="dense"
									variant="outlined"
									autoComplete="off"
									color="primary"
								/>
								<br />
								<TextField
									id="outlined-textarea"
									label={langBase.yourOpinion || "Napisz opinie"}
									placeholder=""
									multiline
									className={classes.textField}
									margin="normal"
									variant="outlined"
									rows="4"
									rowsMax="4"
									name="comment"
									color="primary"
								/>
								<br />
								<br />
								{error}
								<div
									id="recaptcha"
									className="g-recaptcha"
									data-sitekey="6LevBP0SAAAAAKlGPeuz_lAhBKAtESW1P1DdGYEC"
								/>
								<br />
								<SendButton type="submit" text={langBase.addOpinion} />
								<br />
								<br />
							</form>
						</div>
					</div>
				</article>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	langBase: state.langBase,
	fetching: state.fetching
});

const mapDispatchToProps = {
	fetchLoaderRun
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddOpinion));

//export default withStyles(styles)(AddOpinion);
